"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioAttachment;

function AudioAttachment(_ref) {
  var avatarSize = _ref.avatarSize;
  return {
    // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
    display: 'flex',
    minHeight: avatarSize
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvQXVkaW9BdHRhY2htZW50LnRzIl0sIm5hbWVzIjpbIkF1ZGlvQXR0YWNobWVudCIsImF2YXRhclNpemUiLCJkaXNwbGF5IiwibWluSGVpZ2h0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EsZUFBVCxPQUE2RDtBQUFBLE1BQWxDQyxVQUFrQyxRQUFsQ0EsVUFBa0M7QUFDMUUsU0FBTztBQUNMO0FBQ0FDLElBQUFBLE9BQU8sRUFBRSxNQUZKO0FBR0xDLElBQUFBLFNBQVMsRUFBRUY7QUFITixHQUFQO0FBS0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEF1ZGlvQXR0YWNobWVudCh7IGF2YXRhclNpemUgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgLy8gVE9ETzogW1AyXSBXZSBzaG91bGQgbm90IHNldCBcImRpc3BsYXlcIiBpbiBzdHlsZVNldCwgdGhpcyB3aWxsIGFsbG93IHRoZSB1c2VyIHRvIGJyZWFrIHRoZSBsYXlvdXQgZm9yIG5vIGdvb2QgcmVhc29ucy5cbiAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgbWluSGVpZ2h0OiBhdmF0YXJTaXplXG4gIH07XG59XG4iXX0=